module.exports = {
  baseUrl: {
    core: '/core',
    storage: '/storage',
    intgen: '/intgen',
    demo: '/demo',
    history: '/history',
    intbls: '/intbls',
    extpko: '/extpko',
    finance: '/finance',
    extemn: '/extemn',
    extpzn: '/extpzn',
    extrev: '/extrev',
    extacn: '/extacn',
    extshp: '/extshp',
    extuni: '/extuni',
    intmil: '/intmil',
    intvig: '/intvig',
    intvhs: '/intvhs'
  },
  refreshTokenExpirationTime: 60 * 60 * 1000, // 1h
  refreshTokenUrl: 'security/refresh-token'
}
